import { Box as MuiBox, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import PageHeader from '../shared/PageHeader';

const PREFIX = 'SupportPage';

const classes = {
  container: `${PREFIX}-container`,
};

const Box = styled(MuiBox)(({ theme }) => ({
  [`&.${classes.container}`]: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
  },
}));

const SupportPage = () => {
  const { t } = useTranslation('common');

  return (
    <>
      <Box className={classes.container}>
        <PageHeader title={t('member.support')} />
      </Box>
    </>
  );
};

export default SupportPage;
